import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const linkOverrides: Overrides = {
  MuiLink: {
    root: {
      cursor: 'pointer',
      color: CORPORATE_COLORS.PRIMARY,
      textDecoration: 'none',
      fontWeight: 500
    }
  }
};
